export enum TIME_RANGE {
  LAST_24_HOURS = 1,
  LAST_7_DAYS = 7,
  LAST_30_DAYS = 30,
}
